import angular from 'angular'

angular.module('fieldTransformation.services', []);

angular.module('fieldTransformation', ['fieldTransformation.services']);